var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-menu"},[_c('div',{staticClass:"active-menu-item-cover",style:({top: `${_vm.coverTop}px`})},[_c('div',{staticClass:"active-slide-menu",style:({transform: `translateY(${_vm.activeTranslateY}px)`})},[_vm._t("default")],2)]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }